export default {
  analytics: '/analytics/:campaignId',
  dashboard: '/',
  static: '/static/:iconName',
  emailNotification: '/user/profile/notification',
  downloadReport: '/user/profile/reports',
  subscriptions: '/user/profile/subscriptions',
  overview: '/analytics/:campaignId/overview',
  competitionAnalysis: '/competition-analysis',
}
